import React from 'react';
import { RecallsApiResponse } from '../../../services/recalls-service/recalls-service';
import { RecallsProps } from '../recalls/hook/use-recalls-content';
import AppConfigurationService from '../../../services/app-configuration-service/app-configuration-service';

interface Props {
    appConfig: AppConfigurationService;
    recallData: RecallsApiResponse | null | undefined;
    recallsContent: RecallsProps;
    showRecalls: boolean;
    showCsp: boolean;
    isYmm: boolean;
    isImgTakataCampaignIdPresent: boolean;
    isImgTakataRoute: boolean;
}

export const RecallsCspDisclaimer = (props: Props) => {
    const {
        appConfig,
        recallData,
        recallsContent,
        showRecalls,
        showCsp,
        isYmm,
        isImgTakataCampaignIdPresent,
        isImgTakataRoute,
    } = props;
    const isAustralia = appConfig.current3LetterCountryCode === 'aus';
    const hasCsp = !isYmm && recallData?.cspCount && recallData?.cspCount > 0;
    const hasValidRecallsCount =
        !isYmm && recallData?.recallsCount && recallData.recallsCount > 0;
    const hasRecalls = isImgTakataRoute
        ? hasValidRecallsCount && isImgTakataCampaignIdPresent
        : hasValidRecallsCount;
    const hasBothRecallsAndCsp = hasRecalls && hasCsp;
    const hasRecallsAndNoCsp = hasRecalls && !hasCsp;
    const hasNoRecallsAndCsp = !hasRecalls && hasCsp;
    const hasNoRecallsAndNoCsp = !hasRecalls && !hasCsp;

    const renderAustraliaDisclaimers = () => {
        const disclaimerMapping = [
            {
                id: 'recallsAndCspWithRecallsDisclaimer',
                condition: showRecalls && hasBothRecallsAndCsp,
                content: recallsContent.recallsAndCspWithRecallsDisclaimer,
            },
            {
                id: 'recallsAndCspWithCspDisclaimer',
                condition: showCsp && hasBothRecallsAndCsp,
                content: recallsContent.recallsAndCspWithCspDisclaimer,
            },
            {
                id: 'recallsAndNoCspWithRecallsDisclaimer',
                condition: showRecalls && hasRecallsAndNoCsp,
                content: recallsContent.recallsAndNoCspWithRecallsDisclaimer,
            },
            {
                id: 'recallsAndNoCspWithCspDisclaimer',
                condition: showCsp && hasRecallsAndNoCsp,
                content: recallsContent.recallsAndNoCspWithCspDisclaimer,
            },
            {
                id: 'noRecallsAndCspWithRecallsDisclaimer',
                condition: showRecalls && hasNoRecallsAndCsp,
                content: recallsContent.noRecallsAndCspWithRecallsDisclaimer,
            },
            {
                id: 'noRecallsAndCspWithCspDisclaimer',
                condition: showCsp && hasNoRecallsAndCsp,
                content: recallsContent.noRecallsAndCspWithCspDisclaimer,
            },
            {
                id: 'noRecallsAndNoCspWithRecallsDisclaimer',
                condition: showRecalls && hasNoRecallsAndNoCsp,
                content: recallsContent.noRecallsAndNoCspWithRecallsDisclaimer,
            },
            {
                id: 'noRecallsAndNoCspWithCspDisclaimer',
                condition: showCsp && hasNoRecallsAndNoCsp,
                content: recallsContent.noRecallsAndNoCspWithCspDisclaimer,
            },
            {
                id: 'imgTakataRecallsDisclaimer',
                condition: showRecalls && isImgTakataRoute,
                content: recallsContent.detailsMarketDisclaimer,
            },
        ];

        return disclaimerMapping.map(({ id, condition, content }) => {
            if (condition && content) {
                return (
                    <div
                        key={id}
                        className="recalls-disclaimer"
                        dangerouslySetInnerHTML={{
                            __html: content.trim(),
                        }}
                    />
                );
            }
            return null;
        });
    };

    const renderDefaultDisclaimers = () => (
        <>
            {recallsContent.detailsMarketDisclaimer &&
                !isYmm &&
                showRecalls && (
                    <div className="recalls-disclaimer">
                        {recallsContent.detailsMarketDisclaimer}
                    </div>
                )}
            {recallsContent.cspDisclaimer && !isYmm && showCsp && (
                <div className="recalls-disclaimer">
                    {recallsContent.cspDisclaimer}
                </div>
            )}
        </>
    );

    return (
        <>
            {!isAustralia
                ? renderDefaultDisclaimers()
                : renderAustraliaDisclaimers()}
        </>
    );
};
